import React from 'react';
import { Redirect } from 'react-router-dom';
import { Route } from 'react-router-dom';
import * as FeatherIcon from 'react-feather';

import { isUserAuthenticated, getLoggedInUser, getBadgeChat, getBadgeMaintenance } from '../helpers/authUtils';

//info
const Policy = React.lazy(() => import('../pages/info/policy'));
const Aboutus = React.lazy(() => import('../pages/info/aboutus'));
const TermCondition = React.lazy(() => import('../pages/info/term-condition'));
const LandingPage = React.lazy(() => import('../pages/landing/landing-page'));


// finance
const FinancePlumbingAdd = React.lazy(() => import('../pages/finance/plumbing/add'));
const FinancePlumbingImport = React.lazy(() => import('../pages/finance/plumbing/import'));
const FinancePlumbingStatus = React.lazy(() => import('../pages/finance/plumbing/status'));
const FinancePlumbingConfirm = React.lazy(() => import('../pages/finance/plumbing/confirm'));
const FinancePlumbingPrint = React.lazy(() => import('../pages/finance/plumbing/print'));
const FinancePlumbingHistories = React.lazy(() => import('../pages/finance/plumbing/histories'));
const FinanceCentralAdd = React.lazy(() => import('../pages/finance/central/add'));
const FinanceCentralImport = React.lazy(() => import('../pages/finance/central/import'));
const FinanceCentralStatus = React.lazy(() => import('../pages/finance/central/list'));
const FinanceCentralConfirm = React.lazy(() => import('../pages/finance/central/confirm'));
const FinanceCentralPrint = React.lazy(() => import('../pages/finance/central/print'));
const FinanceCentralHistories = React.lazy(() => import('../pages/finance/central/histories'));

// repair
const RepairList = React.lazy(() => import('../pages/repair/list'));
const RepairStatus = React.lazy(() => import('../pages/repair/status'));
const RepairComplete = React.lazy(() => import('../pages/repair/complete'));
const RepairRating = React.lazy(() => import('../pages/repair/rating'));
const RepairPrint = React.lazy(() => import('../pages/repair/print'));
const RepairCalendar = React.lazy(() => import('../pages/repair/calendar'));
const RepairAdminDuty = React.lazy(() => import('../pages/repair/adminDutyList'));
const RepairHistories = React.lazy(() => import('../pages/repair/histories'));
const RepairSettings = React.lazy(() => import('../pages/repair/settings'));
const RepairAdd = React.lazy(() => import('../pages/repair/add'));

// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));
const Register = React.lazy(() => import('../pages/auth/Register'));
const ForgetPassword = React.lazy(() => import('../pages/auth/ForgetPassword'));
const ConfirmResetPassword = React.lazy(() => import('../pages/auth/ConfirmResetPassword'));
const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
// dashboard
const Dashboard = React.lazy(() => import('../pages/dashboard'));

const Widgets = React.lazy(() => import('../pages/uikit/Widgets/'));

//general
const GeneralList = React.lazy(() => import('../pages/general/list'));
const GeneralWaitingList = React.lazy(() => import('../pages/general/waitingList'));
const GeneralHistories = React.lazy(() => import('../pages/general/histories'));

//mail
const MailAdd = React.lazy(() => import('../pages/mail/add'));
const MailList = React.lazy(() => import('../pages/mail/list'));
const MailSearch = React.lazy(() => import('../pages/mail/search'));
const MailHistories = React.lazy(() => import('../pages/mail/histories'));
const MailPrint = React.lazy(() => import('../pages/mail/print'));
const MailSettings = React.lazy(() => import('../pages/mail/settings'));

//announce
const AnnounceAdd = React.lazy(() => import('../pages/announce/add'));
const AnnounceList = React.lazy(() => import('../pages/announce/list'));
const AnnounceHistories = React.lazy(() => import('../pages/announce/histories'));

// account
const AccountHomeAdd = React.lazy(() => import('../pages/account/home/clientAdd'));
const AccountHomeAddImport = React.lazy(() => import('../pages/account/home/clientAddImport'));
const AccountHomeList = React.lazy(() => import('../pages/account/home/list'));

const AccountClientAdd = React.lazy(() => import('../pages/account/homeLicense/clientAdd'));
const AccountClientAddImport = React.lazy(() => import('../pages/account/homeLicense/clientAddImport'));
// const AccountClientList = React.lazy(() => import('../pages/account/homeLicense/clientList'));
const AccountLicense = React.lazy(() => import('../pages/account/homeLicense/license'));

const AccountCorporateInfo = React.lazy(() => import('../pages/account/corporationInfo'));
// const AccountTechnician = React.lazy(() => import('../pages/account/technician'));
const AccountRightManangement = React.lazy(() => import('../pages/account/roleManagement'));
const AccountEmergencyContactType = React.lazy(() => import('../pages/account/ermergencyContact/type'));
const AccountEmergencyContactList = React.lazy(() => import('../pages/account/ermergencyContact/list'));
const AccountEnterpriseInfo = React.lazy(() => import('../pages/account/enterpriseInfo'));
const FaqManagement = React.lazy(() => import('../pages/account/faq'));

//Technician
const AccountTechnicianType = React.lazy(() => import('../pages/account/technician/type'));
const AccountTechnicianList = React.lazy(() => import('../pages/account/technician/list'));

//Devices
const DeviceType = React.lazy(() => import('../pages/device/type'));
const DeviceStore = React.lazy(() => import('../pages/device/store'));
const DeviceList = React.lazy(() => import('../pages/device/list'));
const DevicePickup = React.lazy(() => import('../pages/device/pick'));
const DeviceExportList = React.lazy(() => import('../pages/device/export-list'));
const DeviceHistories = React.lazy(() => import('../pages/device/histories'));

//Users
const UserImport = React.lazy(() => import('../pages/account/user/import'));
const UserList = React.lazy(() => import('../pages/account/user/list'));

//Chat
const ChatList = React.lazy(() => import('../pages/chat/list'));
const ChatTechList = React.lazy(() => import('../pages/chat/techlist'));
// const Chat = React.lazy(() => import('../pages/chat/messenger'))
const Tag = React.lazy(() => import('../pages/chat/tag'))


const Report = React.lazy(() => import('../pages/report'));
const Settings = React.lazy(() => import('../pages/settings'));

//========================= ADMIN COMPANY =========================//
const AdminCompanyDashboard = React.lazy(() => import('../pages/admin-company/dashboard'));
const AdminCompanySetting = React.lazy(() => import('../pages/admin-company/setting'));

//========================= ADMIN SUPER =========================//
const AdminSuperDashboard = React.lazy(() => import('../pages/admin-super/dashboard'));
const AdminSuperSetting = React.lazy(() => import('../pages/admin-super/setting'));



// handle auth and authorization
const PrivateRoute = ({ component: Component, roles, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (!isUserAuthenticated()) {
                // not logged in so redirect to login page with the return url
                return <Redirect to={{ pathname: '/account/login', state: { from: props.location } }} />;
                // return <Redirect to={{ pathname: '/landing-page', state: { from: props.location } }} />;
            }

            const loggedInUser = getLoggedInUser();
            // check if route is restricted by role
            if (roles && roles.indexOf(loggedInUser.role) === -1) {
                // role not authorised so redirect to home page
                if(loggedInUser.role==="AdminSuper"){
                    return <Redirect to={{ pathname: '/super-dashboard' }} />;
                }else if(loggedInUser.role==="AdminCompany"){
                    return <Redirect to={{ pathname: '/company-dashboard' }} />;
                }else {
                    return <Redirect to={{ pathname: '/' }} />;
                }
            }

            // authorised so return component
            return <Component {...props} />;
        }}
    />
);

// root routes
const rootRoute = {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard" />,
    route: PrivateRoute,
};

// dashboards
const dashboardRoutes = {
    path: '/dashboard',
    name: 'หน้าหลัก',
    icon: FeatherIcon.Home,
    // header: 'Navigation',
    component: Dashboard,
    roles: ['Admin'],
    route: PrivateRoute,
};

//info
const infoRoutes = {
    path: '/info',
    name: 'Info',
    children: [
        {
            path: '/info/policy',
            name: 'Policy',
            component: Policy,
            route: Route,
        },
        {
            path: '/info/aboutus',
            name: 'Aboutus',
            component: Aboutus,
            route: Route,
        },
        {
            path: '/info/term-condition',
            name: 'Term Condition',
            component: TermCondition,
            route: Route,
        }
    ]
}

// eslint-disable-next-line no-unused-vars
const landingPageRoutes = {
    path: '/landing-page',
    name: 'landing-page',
    component: LandingPage,
    route: Route,
}

// auth
const authRoutes = {
    path: '/account',
    name: 'Auth',
    children: [
        {
            path: '/account/login',
            name: 'Login',
            component: Login,
            route: Route,
        },
        {
            path: '/account/logout',
            name: 'Logout',
            component: Logout,
            route: Route,
        },
        {
            path: '/account/register',
            name: 'Register',
            component: Register,
            route: Route,
        },
        {
            path: '/account/confirm',
            name: 'Confirm',
            component: Confirm,
            route: Route,
        },
        {
            path: '/account/forget-password',
            name: 'Forget Password',
            component: ForgetPassword,
            route: Route,
        },
        {
            path: '/account/confirm-reset-password',
            name: 'Confirm Reset Password',
            component: ConfirmResetPassword,
            route: Route,
        },
    ],
};

// flatten the list of all nested routes
const flattenRoutes = (routes) => {
    let flatRoutes = [];

    routes = routes || [];
    routes.forEach((item) => {
        flatRoutes.push(item);

        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

const generalRoutes = {
    path: '/general',
    name: 'จัดการเรื่องทั่วไป',
    // header: 'การจัดการ',
    icon: FeatherIcon.AlertTriangle,
    children: [
        {
            path: '/general/topic',
            name: 'รายการแจ้งเรื่องทั่วไป',
            component: GeneralList,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/general/waiting-list',
            name: 'รายการรอดำเนินการ',
            component: GeneralWaitingList,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/general/histories',
            name: 'ประวัติแจ้งปัญหาทั่วไป',
            component: GeneralHistories,
            route: PrivateRoute,
            roles: ['Admin'],
        },
    ],
};

const mailRoutes = {
    path: '/mail',
    name: 'จัดการพัสดุ',
    // header: 'การจัดการ',
    icon: FeatherIcon.Package,
    children: [
        {
            path: '/mail/add',
            name: 'เพิ่มรายการพัสดุ',
            component: MailAdd,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/mail/list',
            name: 'รายการพัสดุ',
            component: MailList,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        // {
        //     path: '/mail/search',
        //     name: 'ค้นหารายการพัสดุ',
        //     component: MailSearch,
        //     route: PrivateRoute,
        //     roles: ['Admin'],
        // },
        // {
        //     path: '/mail/print',
        //     name: 'พิมพ์ใบแจ้งพัสดุ',
        //     component: MailPrint,
        //     route: PrivateRoute,
        //     roles: ['Admin'],
        // },
        {
            path: '/mail/histories',
            name: 'ประวัติพัสดุทั้งหมด',
            component: MailHistories,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/mail/settings',
            name: 'ตั้งค่างานพัสดุ',
            component: MailSettings,
            route: PrivateRoute,
            roles: ['Admin'],
        },
    ],
};

const announceRoutes = {
    path: '/announce',
    name: 'จัดการประกาศ',
    // header: 'การจัดการ',
    icon: FeatherIcon.Send,
    children: [
        {
            path: '/announce/new',
            name: 'เพิ่มประกาศ',
            component: AnnounceAdd,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/announce/list',
            name: 'รายการประกาศปัจจุบัน',
            component: AnnounceList,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/announce/histories',
            name: 'ประวัติการประกาศทั้งหมด',
            component: AnnounceHistories,
            route: PrivateRoute,
            roles: ['Admin'],
        },
    ],
};

const repairRoutes = {
    path: '/repair',
    name: 'จัดการซ่อมแซม',
    // header: 'การจัดการ',
    icon: FeatherIcon.Umbrella,
    // badge: {
    //     'variant': 'danger',
    //     'text': getBadgeMaintenance(),
    // },
    children: [
        {
            path: '/repair/add',
            name: 'แจ้งปัญหาการซ่อมแซม',
            component: RepairAdd,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/repair/list',
            name: 'รายการแจ้งซ่อม', //◎ 
            component: RepairList,
            // icon: FeatherIcon.MinusSquare,
            // badge: {
            //     'variant': 'danger',
            //     'text': getBadgeMaintenance(),
            // },
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/repair/status',
            name: 'ติดตามสถานะการซ่อม',
            component: RepairStatus,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/repair/complete',
            name: 'แจ้งซ่อมเสร็จ',
            component: RepairComplete,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/repair/rating',
            name: 'ประเมินการซ่อม',
            component: RepairRating,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/repair/print',
            name: 'พิมพ์ใบนัดหมายช่าง',
            component: RepairPrint,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/repair/calendar',
            name: 'ตารางเวลาซ่อม',
            component: RepairCalendar,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/repair/admin-response',
            name: 'รายการซ่อมที่รับผิดชอบด้วยผู้บริหารส่วนกลาง',
            component: RepairAdminDuty,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/repair/histories',
            name: 'ประวัติการซ่อม',
            component: RepairHistories,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/repair/settings',
            name: 'ตั้งค่ารายการซ่อม',
            component: RepairSettings,
            route: PrivateRoute,
            roles: ['Admin'],
        },
    ],
};

const accountRoutes = {
    path: '/account-management',
    name: 'ทะเบียน',
    // header: 'การจัดการ',
    icon: FeatherIcon.Users,
    children: [
        {
            path: '/account-management/home',
            name: 'เลขที่',
            children: [
                {
                    path: '/account-management/home/home-add',
                    name: 'เพิ่มข้อมูลเลขที่',
                    component: AccountHomeAdd,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
                {
                    path: '/account-management/home/home-import',
                    name: 'นำเข้าข้อมูลเลขที่',
                    component: AccountHomeAddImport,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
                {
                    path: '/account-management/home/list',
                    name: 'รายการเลขที่',
                    component: AccountHomeList,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
            ]
        },
        {
            path: '/account-management/license',
            name: 'เลขที่สัญญา',
            children: [
                {
                    path: '/account-management/license/client-add',
                    name: 'เพิ่มข้อมูลสัญญา',
                    component: AccountClientAdd,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
                {
                    path: '/account-management/license/client-import',
                    name: 'นำเข้าข้อมูลสัญญา',
                    component: AccountClientAddImport,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
                // {
                //     path: '/account-management/license/client-list',
                //     name: 'ข้อมูลสมาชิกลูกบ้าน',
                //     component: AccountClientList,
                //     route: PrivateRoute,
                //     roles: ['Admin'],
                // },
                {
                    path: '/account-management/license/list',
                    name: 'ข้อมูลเลขที่สัญญา',
                    component: AccountLicense,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
            ]
        },
        {
            path: '/account-management/technician',
            name: 'ข้อมูลช่าง',
            // header: 'การจัดการ',
            // icon: FeatherIcon.PhoneCall,
            children: [
                {
                    path: '/account-management/technician/type',
                    name: 'ประเภทงานช่าง',
                    component: AccountTechnicianType,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
                {
                    path: '/account-management/technician/list',
                    name: 'รายชื่อช่าง',
                    component: AccountTechnicianList,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
            ]
        },
        {
            path: '/account-management/emergency-contact',
            name: 'การติดต่อฉุกเฉิน',
            // header: 'การจัดการ',
            // icon: FeatherIcon.PhoneCall,
            children: [
                {
                    path: '/account-management/emergency-contact/type',
                    name: 'กลุ่มติดต่อฉุกเฉิน',
                    component: AccountEmergencyContactType,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
                {
                    path: '/account-management/emergency-contact/list',
                    name: 'รายการติดต่อฉุกเฉิน',
                    component: AccountEmergencyContactList,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
            ]
        },
        {
            path: '/account-management/user',
            name: 'ข้อมูลผู้ใช้งาน',
            // header: 'การจัดการ',
            // icon: FeatherIcon.PhoneCall,
            children: [
                // {
                //     path: '/account-management/user/import',
                //     name: 'นำเข้าข้อมูลผู้ใช้งาน',
                //     component: UserImport,
                //     route: PrivateRoute,
                //     roles: ['Admin'],
                // },
                {
                    path: '/account-management/user/list',
                    name: 'ผู้ใช้งานปัจจุบัน',
                    component: UserList,
                    route: PrivateRoute,
                    roles: ['Admin'],
                },
            ]
        },
        {
            path: '/account-management/corporation-info',
            name: 'ข้อมูลผู้บริหารส่วนกลาง',
            component: AccountCorporateInfo,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/account-management/role-management',
            name: 'จัดการสิทธิ์เข้าใช้งาน',
            component: AccountRightManangement,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/account-management/enterprise-info',
            name: 'ข้อมูลโครงการ',
            component: AccountEnterpriseInfo,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/account-management/faq',
            name: 'จัดการคำถามที่พบบ่อย (FAQ)',
            component: FaqManagement,
            route: PrivateRoute,
            roles: ['Admin'],
        },
    ],
};

const fiananceRoutes = {
    path: '/finance',
    name: 'บัญชีการเงิน',
    icon: FeatherIcon.Umbrella,
    children: [
        {
            path: '/finance/plumbing-add',
            name: 'เพิ่มแจ้งสาธารณูปโภค',
            component: FinancePlumbingAdd,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/finance/plumbing-import',
            name: 'นำเข้าสาธารณูปโภค',
            component: FinancePlumbingImport,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/finance/plumbing-status',
            name: 'ติดตามสาธารณูปโภค',
            component: FinancePlumbingStatus,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/finance/plumbing-confirm',
            name: 'ยืนยันชำระสาธารณูปโภค',
            component: FinancePlumbingConfirm,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        // {
        //     path: '/finance/plumbing-print',
        //     name: 'พิมพ์ใบแจ้งสาธารณูปโภค',
        //     component: FinancePlumbingPrint,
        //     route: PrivateRoute,
        //     roles: ['Admin'],
        // },
        {
            path: '/finance/plumbing-histories',
            name: 'ประวัติการชำระสาธารณูปโภค',
            component: FinancePlumbingHistories,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/finance/central-add',
            name: 'เพิ่มการแจ้งค่าส่วนกลาง',
            component: FinanceCentralAdd,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/finance/central-import',
            name: 'นำเข้าค่าส่วนกลาง',
            component: FinanceCentralImport,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/finance/central-status',
            name: 'ติดตามค่าส่วนกลาง',
            component: FinanceCentralStatus,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/finance/central-confirm',
            name: 'ยืนยันชำระค่าส่วนกลาง',
            component: FinanceCentralConfirm,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        // {
        //     path: '/finance/central-print',
        //     name: 'พิมพ์ใบแจ้งค่าส่วนกลาง',
        //     component: FinanceCentralPrint,
        //     route: PrivateRoute,
        //     roles: ['Admin'],
        // },
        {
            path: '/finance/central-histories',
            name: 'ประวัติการชำระส่วนกลาง',
            component: FinanceCentralHistories,
            route: PrivateRoute,
            roles: ['Admin'],
        },
    ],
};

// const messengerRoutes = {
//     path: '/messenger',
//     name: 'แชทข้อความ',
//     icon: FeatherIcon.MessageSquare,
//     component: ChatList,
//     route: PrivateRoute,
//     roles: ['Admin'],
// };

const chatRoutes = {
    path: '/chat',
    name: 'กล่องข้อความ',
    icon: FeatherIcon.MessageSquare,
    // component: Chat,
    route: PrivateRoute,
    roles: ['Admin'],
    // badge: {
    //     'variant': 'danger',
    //     'text': getBadgeChat(),
    // },
    children: [
        
        {
            path: '/chat/list',
            name: 'กระทู้ข้อความ',
            // badge: {
            //     'variant': 'danger',
            //     'text': getBadgeChat(),
            // },
            component: ChatList,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/chat/techlist',
            name: 'กระทู้ข้อความช่าง',
            // badge: {
            //     'variant': 'danger',
            //     'text': getBadgeChat(),
            // },
            component: ChatTechList,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/chat/tag',
            name: 'รายการแท็ก',
            component: Tag,
            route: PrivateRoute,
            roles: ['Admin'],
        },

    ],
};

const deviceRoutes = {
    path: '/device',
    name: 'อุปกรณ์',
    icon: FeatherIcon.Disc,
    // component: Chat,
    // route: PrivateRoute,
    // roles: ['Admin'],
    children: [
        {
            path: '/device/list',
            name: 'รายการอุปกรณ์',
            component: DeviceList,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/device/pick',
            name: 'เบิกอุปกรณ์',
            component: DevicePickup,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/device/export-list',
            name: 'รายการเบิกอุปกรณ์',
            component: DeviceExportList,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/device/histories',
            name: 'ประวัติรายการอุปกรณ์',
            component: DeviceHistories,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/device/type',
            name: 'ประเภทอุปกรณ์',
            component: DeviceType,
            route: PrivateRoute,
            roles: ['Admin'],
        },
        {
            path: '/device/store',
            name: 'คลังอุปกรณ์',
            component: DeviceStore,
            route: PrivateRoute,
            roles: ['Admin'],
        },
    ],
};

const settingRoutes = {
    path: '/settings',
    name: 'ตั้งค่า',
    icon: FeatherIcon.Settings,
    component: Settings,
    route: PrivateRoute,
    roles: ['Admin'],
};
const reportRoutes = {
    path: '/summary-report',
    name: 'รายงานสำหรับผู้บริหาร',
    icon: FeatherIcon.Tag,
    component: Report,
    route: PrivateRoute,
    roles: ['Admin'],
};
const widget = {
    path: '/widget',
    name: 'รายงานสำหรับผู้บริหาร',
    icon: FeatherIcon.Tag,
    component: Widgets,
    route: PrivateRoute,
    roles: ['Admin'],
};


//============================== START ADMIN CONTROL ====================================//
const adminCompanyDashboadRoutes = {
    path: '/company-dashboard',
    name: 'หน้าหลัก',
    icon: FeatherIcon.Home,
    component: AdminCompanyDashboard,
    route: PrivateRoute,
    roles: ['AdminCompany'],
};

const adminCompanySettingRoutes = {
    path: '/company-setting',
    name: 'ตั้งค่า',
    icon: FeatherIcon.Settings,
    component: AdminCompanySetting,
    route: PrivateRoute,
    roles: ['AdminCompany'],
};

const adminSuperDashboadRoutes = {
    path: '/super-dashboard',
    name: 'หน้าหลัก',
    icon: FeatherIcon.Home,
    component: AdminSuperDashboard,
    route: PrivateRoute,
    roles: ['AdminSuper'],
};

const adminSuperSettingRoutes = {
    path: '/super-setting',
    name: 'ตั้งค่า',
    icon: FeatherIcon.Settings,
    component: AdminSuperSetting,
    route: PrivateRoute,
    roles: ['AdminSuper'],
};
//============================== END  ADMIN CONTROL ====================================//

// All routes
const allRoutes = [
    landingPageRoutes,
    rootRoute,
    authRoutes,
    infoRoutes,
    dashboardRoutes,
    generalRoutes,
    repairRoutes,
    mailRoutes,
    announceRoutes,
    // messengerRoutes,
    fiananceRoutes,
    accountRoutes,
    deviceRoutes,
    reportRoutes,
    settingRoutes,
    chatRoutes,
    widget,

    adminCompanyDashboadRoutes,
    adminCompanySettingRoutes,
    adminSuperDashboadRoutes,
    adminSuperSettingRoutes,
];

const authProtectedRoutes = () => {
    const loggedInUser = getLoggedInUser();
    //console.log("check rout role: " + loggedInUser.role);
    if (loggedInUser && loggedInUser.role === "AdminSuper") {
        return [
            adminSuperDashboadRoutes,
            adminSuperSettingRoutes,
        ];
    } else if (loggedInUser && loggedInUser.role === "AdminCompany") {
        return [
            adminCompanyDashboadRoutes,
            adminCompanySettingRoutes,
        ];
    } else {
        return [
            dashboardRoutes,
            generalRoutes,
            repairRoutes,
            mailRoutes,
            announceRoutes,
            chatRoutes,
            fiananceRoutes,
            accountRoutes,
            deviceRoutes,
            reportRoutes,
            settingRoutes,
        ];
    }
}

// const authProtectedRoutes = [
//     dashboardRoutes,
//     generalRoutes,
//     repairRoutes,
//     mailRoutes,
//     announceRoutes,
//     // messengerRoutes,
//     chatRoutes,
//     fiananceRoutes,
//     accountRoutes,
//     deviceRoutes,
//     reportRoutes,
//     settingRoutes,

//     // adminCompanyDashboadRoutes,
//     // adminCompanySettingRoutes,
//     // adminSuperDashboadRoutes,
//     // adminSuperSettingRoutes,
// ];

// const authAdminCompanyProtectedRoutes = [
//     adminCompanyDashboadRoutes,
//     adminCompanySettingRoutes,
// ];

// const authAdminSuperProtectedRoutes = [
//     adminSuperDashboadRoutes,
//     adminSuperSettingRoutes,
// ];

const allFlattenRoutes = flattenRoutes(allRoutes);
export { allRoutes, authProtectedRoutes, allFlattenRoutes };